import axios from "axios";

export const request = axios.create({
  baseURL: "https://tabeeb-assyut-api.onrender.com",
});


